import { render, staticRenderFns } from "./ListaReceitas.vue?vue&type=template&id=3e495432&"
import script from "./ListaReceitas.vue?vue&type=script&lang=js&"
export * from "./ListaReceitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports